import http from "@/helper/http";
import {BaseVO, GetByIdBO, PaginationBO, PaginationVO} from "@/model/global";
import {useMutation, useQuery} from "@tanstack/react-query";
import {WritePlanForm} from "@/pages/Plan/WritePlan";
import {SearchBO} from "@/service/common.s";
import {PlanPO} from "@/model/mission";

export enum PlanEnum {
    GetPlanPage = "/plan/getPlanPage",
    GetPlan = "/plan/getPlan",
    CreatePlan = "/plan/createPlan",
    SearchPlan = "/plan/searchPlan",
    GetPlanBoard = "/plan/getPlanBoard",
    UpdatePlan = "/plan/updatePlan",
}

export interface PlanPageBO {
    keyword?: string;
}

export interface SearchPlanVO extends PlanPO {
    planName: string;
    id: number
}

export interface PlanPageVO extends PlanPO {
}

export interface PlanBoardVO {
    [key: string]: PaginationVO<PlanPO>;
}

export interface PlanBoardBO extends PaginationBO {
    statusId: number
}

export const useQueryPlanPage = () => useMutation<BaseVO<PaginationVO<PlanPageVO>>, null, PlanPageBO>({
    mutationFn: (data: PlanPageBO) => http.post<BaseVO<PaginationVO<PlanPageVO>>>({
        url: PlanEnum.GetPlanPage,
        data: data,
    }),
})

export const useQueryPlan = (params: GetByIdBO, enabled?: boolean) => useQuery<BaseVO<PlanPO>>({
    queryKey: [params.id], queryFn: () => http.get<BaseVO<PlanPO>>({
        url: PlanEnum.GetPlan,
        params: params
    }),
    enabled: enabled,
})

export const useCreatePlan = () => useMutation({
    mutationFn: (data: WritePlanForm) => http.put<BaseVO<null>>({url: PlanEnum.CreatePlan, data}),
})

export const useUpdatePlan = () => useMutation({
    mutationFn: (data: WritePlanForm) => http.post<BaseVO<null>>({url: PlanEnum.UpdatePlan, data}),
})

export const useQueryPlanBoard = () => useMutation({
    mutationFn: (data: PlanBoardBO) => http.post<BaseVO<PlanBoardVO>>({
        url: PlanEnum.GetPlanBoard,
        data
    })
})

export const useSearchPlan = () => useMutation({
    mutationFn: (data: SearchBO) => http.post<BaseVO<SearchPlanVO[]>>({url: PlanEnum.SearchPlan, data})
})


